import { render, staticRenderFns } from "./eventDetail.vue?vue&type=template&id=20e343b0&scoped=true&"
import script from "./eventDetail.vue?vue&type=script&lang=js&"
export * from "./eventDetail.vue?vue&type=script&lang=js&"
import style0 from "./eventDetail.vue?vue&type=style&index=0&id=20e343b0&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e343b0",
  null
  
)

export default component.exports